var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-bar__label",class:[`top-bar__label--align-${_vm.align}`]},[_c('span',{staticClass:"top-bar__label__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }